/**
 * Branded QR for a URL: encode here, render with the shared Parkify signage
 * style (`@parkify/ui/qr-brand`, which documents the geometry and why 'H').
 * `qrcode` stays this app's dependency so only one encoder is ever bundled.
 * Async so the call sites don't change (`qrcode`'s create() is synchronous,
 * but one call site consumes this as a promise).
 */
import QRCode from 'qrcode'
import { renderBrandedQrSvg } from '@parkify/ui/qr-brand'

export async function generateBrandedQrSvg(url: string): Promise<string> {
  return renderBrandedQrSvg(QRCode.create(url, { errorCorrectionLevel: 'H' }).modules)
}
